module.exports = __webpack_public_path__ + "img/delete-workflow.cda97b6c.svg";